import './App.css';
import NoteFoundPage from './Componantes/Pages/NoteFoundPage';

function App() {
  return (
    <div className="App">
      <NoteFoundPage />
    </div>
  );
}

export default App;
